module.exports = __webpack_public_path__ + "static/img/three.2fef528.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guoguoImg/three.png
// module id = Ywr3
// module chunks = 1